import { create } from 'zustand';
import type { ConversationStatus, LeadStatus } from '@conversia/shared-types';
import type { ConversationWithRelations } from '@/lib/types';

export type ConversationTypeFilter = 'all' | 'individual' | 'group';

export interface ConversationFilters {
  status?: ConversationStatus;
  /** Temperatura comercial del lead (pestañas del inbox). */
  leadStatus?: LeadStatus;
  channelId?: string;
  search?: string;
  /** Tipo de contacto: 'all' (default) | 'individual' | 'group'. */
  type?: ConversationTypeFilter;
}

interface ConversationsState {
  items: ConversationWithRelations[];
  currentId: string | null;
  filters: ConversationFilters;

  setItems: (items: ConversationWithRelations[]) => void;
  setCurrent: (id: string | null) => void;
  setFilters: (filters: Partial<ConversationFilters>) => void;
  resetFilters: () => void;
}

export const useConversationsStore = create<ConversationsState>((set) => ({
  items: [],
  currentId: null,
  filters: {},

  setItems: (items) => set({ items }),
  setCurrent: (currentId) => set({ currentId }),
  setFilters: (filters) => set((s) => ({ filters: { ...s.filters, ...filters } })),
  resetFilters: () => set({ filters: {} }),
}));
